import ApiService from '@/services/api.service'

const UtilsService = {
  
  getExecuteSP(request) {
      return ApiService.post('/Utils/ExecuteSP', request); 
  }
}
  
export default UtilsService;